import dataAccess from '../services/service.data-access'
import pageBuilder from '../services/pageBuilder'

const state = {
  page: {},
  subPage: {},
  breadcrumbs: {}
}

const getters = {
  page: state => state.page,
  subPage: state => state.subPage,
  breadcrumbs: state => state.breadcrumbs
}

const actions = {
  async loadPage(context, options) {
    var page = {}
    if (options.urlKey === 'welcomebook') {
      page = await dataAccess.getPageWelcomebook()
    } else {
      page = options.page || await dataAccess.getPage(options.urlKey, options.args)
    }
    await pageBuilder.BuildPage(page)
    context.commit('setPage', page)
    context.commit('setBreadcrumbs', page.breadcrumbs)
  },
  clearSubPage(context) {
    context.commit('setSubPage', {})
  },
  clearPage(context) {
    context.commit('setPage', {})
  }
}

const mutations = {
  setPage(state, page) {
    state.page = page
  },
  setSubPage(state, subPage) {
    state.subPage = subPage
  },
  setBreadcrumbs(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
